import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorChartScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M19.6 17.75A2.75 2.75 0 0 0 22.35 15V6a2.75 2.75 0 0 0-2.75-2.75h-15A2.75 2.75 0 0 0 1.85 6v9a2.75 2.75 0 0 0 2.75 2.75h4.7v3.5H7.6a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-1.8v-3.5h4.8Zm-6.3 0v3.5h-2.5v-3.5h2.5ZM20.85 15c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h15c.69 0 1.25.56 1.25 1.25v9Z"
    />
    <path
      fill="#F7A600"
      d="M18.53 7.07a.75.75 0 0 1 0 1.06l-4.097 4.098a.75.75 0 0 1-1.01.046l-2.987-2.489-3.906 3.906a.75.75 0 1 1-1.06-1.06l4.39-4.39a.75.75 0 0 1 1.01-.046l2.986 2.488L17.47 7.07a.75.75 0 0 1 1.06 0Z"
    />
  </svg>
);
export default SvgTwoColorChartScreen;
